"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var MailChimpRequest;
(function (MailChimpRequest) {
    var Contact = (function (_super) {
        __extends(Contact, _super);
        function Contact() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.company = undefined;
            _this.address1 = undefined;
            _this.address2 = undefined;
            _this.city = undefined;
            _this.state = undefined;
            _this.zip = undefined;
            _this.country = undefined;
            _this.phone = undefined;
            return _this;
        }
        return Contact;
    }(BaseModel_1["default"]));
    MailChimpRequest.Contact = Contact;
    var CampaignDefaults = (function (_super) {
        __extends(CampaignDefaults, _super);
        function CampaignDefaults() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /* The default from name for campaigns sent to this list. */
            _this.from_name = undefined;
            /* The default from email for campaigns sent to this list. */
            _this.from_email = undefined;
            /* The default subject line for campaigns sent to this list. */
            _this.subject = undefined;
            return _this;
        }
        return CampaignDefaults;
    }(BaseModel_1["default"]));
    MailChimpRequest.CampaignDefaults = CampaignDefaults;
    var CreateList = (function (_super) {
        __extends(CreateList, _super);
        function CreateList() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = undefined;
            /* The permission reminder for the list */
            _this.permission_reminder = undefined;
            /* Whether campaigns for this list use the Archive Bar in archives by default. */
            _this.use_archive_bar = undefined;
            /* The email address to send subscribe notifications to. */
            _this.notify_on_subscribe = undefined;
            /* The email address to send unsubscribe notifications to. */
            _this.notify_on_unsubscribe = undefined;
            /**
            Whether the list supports multiple formats for emails.
            When set to true, subscribers can choose whether they want to receive HTML or plain-text emails.
            When set to false, subscribers will receive HTML emails, with a plain-text alternative backup.
            */
            _this.email_type_option = undefined;
            /* Whether this list is public or private. */
            _this.visibility = undefined;
            return _this;
        }
        return CreateList;
    }(BaseModel_1["default"]));
    MailChimpRequest.CreateList = CreateList;
    var Location = (function (_super) {
        __extends(Location, _super);
        function Location() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.latitude = undefined;
            _this.longitude = undefined;
            return _this;
        }
        return Location;
    }(BaseModel_1["default"]));
    MailChimpRequest.Location = Location;
    var MergeFields = (function (_super) {
        __extends(MergeFields, _super);
        function MergeFields() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return MergeFields;
    }(BaseModel_1["default"]));
    MailChimpRequest.MergeFields = MergeFields;
    var Members = (function (_super) {
        __extends(Members, _super);
        function Members() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.email_address = undefined;
            /* Type of email this member asked to get (‘html’ or ‘text’). */
            _this.email_type = undefined;
            /* Subscriber’s current status. */
            _this.status = undefined;
            // interests: string = undefined;
            /* If set/detected, the subscriber’s language. */
            _this.language = undefined;
            /* VIP status for subscriber. */
            _this.vip = undefined;
            /* IP address the subscriber signed up from. */
            _this.ip_signup = undefined;
            /* The date and time the subscriber signed up for the list. */
            _this.timestamp_signup = undefined;
            /* The IP address the subscriber used to confirm their opt-in status. */
            _this.ip_opt = undefined;
            /* The date and time the subscribe confirmed their opt-in status. */
            _this.timestamp_opt = undefined;
            return _this;
        }
        return Members;
    }(BaseModel_1["default"]));
    MailChimpRequest.Members = Members;
    var Subscribe = (function (_super) {
        __extends(Subscribe, _super);
        function Subscribe() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /* Whether this batch operation will change existing members’ subscription status. */
            _this.update_existing = undefined;
            return _this;
        }
        return Subscribe;
    }(BaseModel_1["default"]));
    MailChimpRequest.Subscribe = Subscribe;
    var Stats = (function (_super) {
        __extends(Stats, _super);
        function Stats() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.member_count = undefined;
            _this.open_rate = undefined;
            _this.click_rate = undefined;
            return _this;
        }
        return Stats;
    }(BaseModel_1["default"]));
    MailChimpRequest.Stats = Stats;
    var List = (function (_super) {
        __extends(List, _super);
        function List() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = undefined;
            _this.stats = undefined;
            return _this;
        }
        return List;
    }(BaseModel_1["default"]));
    MailChimpRequest.List = List;
    var All = (function (_super) {
        __extends(All, _super);
        function All(lists) {
            var _this = _super.call(this) || this;
            _this.lists = undefined;
            return _this;
        }
        return All;
    }(BaseModel_1["default"]));
    MailChimpRequest.All = All;
})(MailChimpRequest = exports.MailChimpRequest || (exports.MailChimpRequest = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/mailchimp.js
// module id = ../model/dist/models/mailchimp.js
// module chunks = main